module.exports = __webpack_public_path__ + "img/reports.0c92d1a2.svg";